import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from "react"
import { CloseIcon, DropdownContainerBodyWrapper, DropdownContainerWrapper, HeaderTitle, Background } from "./DropdownContainer.css"
import { isPhone } from "../../../../utils/utilities"
import DropdownBody from "../DropdownBody"
import DropdownFooter from "../DropdownFooter"
import translationResource from '../../../../translations.json'
import { useTranslation } from "../../../../hooks"
import { ELanguage, Images } from "@microfrontends/react-components"

export interface IDropdownContainerParams {
    floatingState: any
    filterNumber: number
    customOptions: ReactNode[]
    showState: [boolean, Dispatch<SetStateAction<boolean>>]
    handleClickClearAll: () => void
    handleMoreFilterApply: () => void
    langCode: ELanguage
    urgentJobComponent: ReactNode
    onClose: () => void
}

const DropdownContainer = (params: IDropdownContainerParams) => {
    const translate = useTranslation(translationResource)
    const { floatingState, showState, filterNumber, customOptions, handleClickClearAll, handleMoreFilterApply, langCode, urgentJobComponent, onClose } = params
    const [isShow, setShow] = showState
    const { refs, context, FloatingPortal } = floatingState
    const [isMounted, setMounted] = useState<boolean>(false)
    const [residualHeight, setResidualHeight] = useState<number>(0)

    const isInMobile = isPhone()

    const onAnimationEnd = () => {
        if (isShow) {
            return
        }
        setMounted(false)
    }

    const handleOnClose = () => {
        setShow(false)
        onClose && onClose()
    }

    const onScroll = () => {
        const filterBarEl = document.querySelector('[data-name="StyledFilterBar"]')
        const boundingRect = filterBarEl.getBoundingClientRect()
        let totalHeight = boundingRect.height
        if (boundingRect.top > 0) {
            totalHeight += boundingRect.top
        }

        if (residualHeight !== totalHeight) {
            setResidualHeight(totalHeight)
        }
    }

    useEffect(() => {
        if (!isShow) {
            return () => window.removeEventListener('scroll', onScroll)
        }
        onScroll()
        setMounted(true)

        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [isShow])

    const dropdownStyle = isInMobile
        ? {}
        : {
              position: context.position,
              bottom: 0,
              right: 0,
              display: context.isReferenceHidden ? 'none' : 'block',
              zIndex: 201
          }

    return isInMobile ? <></> : (
        <FloatingPortal enable={true}>
            {isMounted ? (
                <>
                    <Background onClick={() => {
                        setShow(false)

                    }} />
                    <DropdownContainerWrapper
                        isShow={isShow}
                        ref={refs.setPopup}
                        style={dropdownStyle}
                        onAnimationEnd={onAnimationEnd}
                        residualHeight={residualHeight}
                    >
                        <DropdownContainerBodyWrapper
                            isShow={isShow}
                            isMobile={isInMobile}
                            data-floating-placement='bottom-end'
                        >
                            <HeaderTitle>
                                {translate('Filters')}
                                <CloseIcon onClick={handleOnClose}>
                                    <Images.CloseIcon />
                                </CloseIcon>
                            </HeaderTitle>
                            <DropdownBody customOptions={customOptions} residualHeight={residualHeight} />
                            <DropdownFooter
                                urgentJobComponent={urgentJobComponent}
                                filterNumber={filterNumber}
                                handleClickClearAll={handleClickClearAll}
                                onClose={handleOnClose}
                                handleMoreFilterApply={handleMoreFilterApply}
                                langCode={langCode}
                            />
                        </DropdownContainerBodyWrapper>
                    </DropdownContainerWrapper>
                </>
            ) : <></>}
        </FloatingPortal>
    )
}

export default DropdownContainer
